export default "__VITE_ASSET__5b884935__"